import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as mpdels from './../Models/projektDB.models'
import { Context } from './../Services/context.service'


@Component({
  selector: 'banner-main-component',
  templateUrl: './bannerMain.compnent.html'
})

export class BannerMainComponent implements OnInit {


  constructor(
      public context: Context, 
      private router: Router,
  ) { }

    ngOnInit(): void {
        

    }

    public isActive(url): boolean {
        if (this.router.url.toLowerCase() == url) {
            return true
        } else {
            return  false
        }
    }




}


